import { classNameTag } from '../../../utils/class-name-tag';
const inputTag = (...parts) => classNameTag('Input', ...parts);
const inputIcon = ({ hasStartIcon, hasEndIcon, }) => {
    if (hasStartIcon && hasEndIcon) {
        return 'start-icon end-icon';
    }
    if (hasStartIcon) {
        return 'start-icon';
    }
    if (hasEndIcon) {
        return 'end-icon';
    }
    return undefined;
};
export const InputTags = {
    root: inputTag('root'),
    iconContainer: inputTag('icon-container'),
    input: inputTag('input'),
    icon: inputIcon,
};
//# sourceMappingURL=class-name-tags.js.map